export const printHtml = async (id) => {
    const printContent = document.getElementById(id);
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContent.innerHTML;
    window.print();
    // document.body.innerHTML = originalContents;
    
};